export const APP_WRAPPER = 'rcw-app-wrapper';
